import bdServices125 from './bd-services125'
import bdServices from './bd-services'
var FormData = require('form-data')

const autotanqueServices = {}
const url_local = process.env.API_LOCAL
console.log("🚀 ~ url_local:", url_local)

autotanqueServices.searchRec_All = function (fecha) {
  var currentUrl = window.location.hostname
  console.log(currentUrl)
  if (currentUrl === url_local) {
    return bdServices125.get(`/SCA_Tuxpan/data/getAccesos.php?fecha=${fecha}`)
      .then(res => res.data)
      .catch(e => console.log(e))
  } else {
    return bdServices.get(`/SCA_Tuxpan/data/getAccesos.php?fecha=${fecha}`)
      .then(res => res.data)
      .catch(e => console.log(e))
  }
  // return bdServices125.get('/data/getRecepciones.php')
}

autotanqueServices.searchAccesos_PG_Pendientes = function (pg) {
  var currentUrl = window.location.hostname
  console.log(currentUrl)
  if (currentUrl === url_local) {
    return bdServices125.get(`/SCA_Tuxpan/data/getAcceso_pg.php?pg=${pg}`)
      .then(res => res.data)
      .catch(e => console.log(e))
    } else {
      return bdServices.get(`/SCA_Tuxpan/data/getAcceso_pg.php?pg=${pg}`)
        .then(res => res.data)
        .catch(e => console.log(e))
  }
}

autotanqueServices.searchPG_All = function () {
  var currentUrl = window.location.hostname
  console.log(currentUrl)
  if (currentUrl === url_local) {
    return bdServices125.get('/SCA_Tuxpan/data/autotanques.php')
      .then(res => res.data)
      .catch(e => console.log(e))
    } else {
      return bdServices.get('/SCA_Tuxpan/data/autotanques.php')
        .then(res => res.data)
        .catch(e => console.log(e))
  }
}

autotanqueServices.searchPG = function (q) {
  var currentUrl = window.location.hostname
  console.log(currentUrl)
  if (currentUrl === url_local) {
    return bdServices125.get(`/SCA_Tuxpan/data/autotanqueIndQ.php?pg=${q}`)
      .then(res => res.data)
      .catch(e => console.log(e))
  } else {
    return bdServices.get(`/SCA_Tuxpan/data/autotanqueIndQ.php?pg=${q}`)
      .then(res => res.data)
      .catch(e => console.log(e))
  }
}

// autotanqueServices.searchRec_PG = function (idPG) {
//   var currentUrl = window.location.hostname
//   console.log(currentUrl)
//   if (currentUrl === url_local) {
//     return bdServices125.get(`/SCA_Tuxpan/data/getAcceso_pg_pg.php?pg=${idPG}`)
//       .then(res => res.data)
//       .catch(e => console.log(e))
//   } else {
//     return bdServices.get(`/SCA_Tuxpan/data/getAcceso_pg_pg.php?pg=${idPG}`)
//       .then(res => res.data)
//       .catch(e => console.log(e))
//   }
// }

autotanqueServices.addRecepcion = function (id, fechaRecepcion, fechaReporte, idPort, razonSocial, idOperador, nombreOperador, idVerificador, nombreVerificador) {
  var currentUrl = window.location.hostname
  console.log(currentUrl)
  if (currentUrl === url_local) {
    return bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
  } else {
    return bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
  }
}

autotanqueServices.getAcceso = function (id) {
  var currentUrl = window.location.hostname
  console.log(currentUrl)
  
  if (currentUrl === url_local) {
    return bdServices125.get(`/SCA_Tuxpan/data/getAcceso_id.php?id=${id}`)
      .then(res => res.data)
      .catch(e => console.log(e))
  } else {
    return bdServices.get(`/SCA_Tuxpan/data/getAcceso_id.php?id=${id}`)
      .then(res => res.data)
      .catch(e => console.log(e))
  }
}

autotanqueServices.addAcceso = function (id, fechaLlegada, fechaReporte, pg, claveTurno, idOperador, nombreOperador, fotoOperador, telefonoOperador, idUser_lleg, usuario_lleg, subgrupo) {
  var currentUrl = window.location.hostname
  console.log(currentUrl)
  let formData = new FormData()
  formData.append('id', id)
  formData.append('fechaLlegada', fechaLlegada)
  formData.append('fechaReporte', fechaReporte)
  formData.append('pg', pg)
  formData.append('claveTurno', claveTurno)
  formData.append('idOperador', idOperador)
  formData.append('nombreOperador', nombreOperador)
  formData.append('telefono', telefonoOperador)
  formData.append('foto', fotoOperador)
  formData.append('idUser_lleg', idUser_lleg)
  formData.append('usuario_lleg', usuario_lleg)
  formData.append('subgrupo', subgrupo)
  
  const options = {
    method: 'POST',
    headers: { 'content-type': 'multipart/form-data' },
    data: formData,
    url: '/SCA_Tuxpan/addAcceso.php'
  }
  if (currentUrl === url_local) {
    return bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
  } else {
    return bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
  }
}

autotanqueServices.updateAcceso = function (id, fa, iUserAcc, nUserAcc) {
  var currentUrl = window.location.hostname
  console.log(currentUrl)
  let formData = new FormData()
  formData.append('id', id)
  formData.append('fa', fa)
  formData.append('idAcc', iUserAcc)
  formData.append('uAcc', nUserAcc)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    // url: '/addRecepcion_PG.php'
    url: '/SCA_Tuxpan/updateAcceso_Acceso.php'
  }
  if (currentUrl === url_local) {
    return bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
  } else {
    return bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
  }
}

autotanqueServices.updateFH_Facturacion = function (id, fa) {
  var currentUrl = window.location.hostname
  console.log(currentUrl)
  let formData = new FormData()
  formData.append('id', id)
  formData.append('fa', fa)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    // url: '/addRecepcion_PG.php'
    url: '/SCA_Tuxpan/updateAcceso_Fact.php'
  }
  if (currentUrl === url_local) {
    return bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
  } else {
    return bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
  }
}

autotanqueServices.addPG_Rec = function (id, idRec, pg, placas) {
  var currentUrl = window.location.hostname
  console.log(currentUrl)
  let formData = new FormData()
  formData.append('id', id)
  formData.append('id_recepcion', idRec)
  formData.append('pg', pg)
  formData.append('placas', placas)
  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    // url: '/addRecepcion_PG.php'
    url: '/SCA_Tuxpan/addRecepcion_PG.php'
  }
  if (currentUrl === url_local) {
    return bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
  } else {
    return bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
  }
}

autotanqueServices.getDataCarga_Pg_Salida  = function (idPG) {
  var currentUrl = window.location.hostname
  console.log(currentUrl)
  if (currentUrl === url_local) {
    return bdServices125.get(`/SCA_Tuxpan/data/getCarga_Pg_Salida.php?pg=${idPG}`)
      .then(res => res.data)
      .catch(e => console.log(e))
  } else {
    return bdServices.get(`/SCA_Tuxpan/data/getCarga_Pg_Salida.php?pg=${idPG}`)
      .then(res => res.data)
      .catch(e => console.log(e))
  }
}

autotanqueServices.updateDataCargas_recepcion = function (id, entradaCarga, inicioCarga, finCarga, estado) {
  var currentUrl = window.location.hostname
  console.log(currentUrl)
  let formData = new FormData()
  formData.append('id', id)
  formData.append('ec', entradaCarga)
  formData.append('ic', inicioCarga)
  formData.append('fc', finCarga)
  formData.append('es', estado)
  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    // url: '/updatePG.php'
    url: '/SCA_Tuxpan/updateDataCargas_recepcion.php'
  }
  if (currentUrl === url_local) {
    return bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
  } else {
    return bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
  }
}

autotanqueServices.updatePg = function (pg, grupo, placa, comercializadora, porteador, capacidad) {
  var currentUrl = window.location.hostname
  console.log(currentUrl)
  let formData = new FormData()
  formData.append('pg', pg)
  formData.append('grupo', grupo)
  formData.append('placa', placa)
  formData.append('comercializadora', comercializadora)
  formData.append('porteador', porteador)
  formData.append('capacidad', capacidad)
  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    // url: '/updatePG.php'
    url: '/SCA_Tuxpan/updatePG.php'
  }
  if (currentUrl === url_local) {
    return bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
  } else {
    return bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
  }
}

autotanqueServices.getVerificacion = function (q) {
  var currentUrl = window.location.hostname
  console.log(currentUrl)
  console.log(q)
  if (currentUrl === url_local) {
    return bdServices125.get(`/SCA_Tuxpan/data/verificacionesInd.php?id=${q}`)
      .then(res => res.data)
      .catch(e => console.log(e))
  } else {
    return bdServices.get(`/SCA_Tuxpan/data/verificacionesInd.php?id=${q}`)
      .then(res => res.data)
      .catch(e => console.log(e))
  }
}

autotanqueServices.getPgsVerifInd = function (q) {
  var currentUrl = window.location.hostname
  console.log(currentUrl)
  console.log(q)
  if (currentUrl === url_local) {
    return bdServices125.get(`/SCA_Tuxpan/data/getVerificacionInd.php?id=${q}`)
      .then(res => res.data)
      .catch(e => console.log(e))
  } else {
    return bdServices.get(`/SCA_Tuxpan/data/getVerificacionInd.php?id=${q}`)
      .then(res => res.data)
      .catch(e => console.log(e))
  }
}

autotanqueServices.getPuntos_PG = function (q) {
  var currentUrl = window.location.hostname
  console.log(currentUrl)
  console.log(q)
  if (currentUrl === url_local) {
    return bdServices125.get(`/SCA_Tuxpan/data/getPuntos_PG.php?id=${q}`)
      .then(res => res.data)
      .catch(e => console.log(e))
  } else {
    return bdServices.get(`/SCA_Tuxpan/data/getPuntos_PG.php?id=${q}`)
      .then(res => res.data)
      .catch(e => console.log(e))
  }
}

autotanqueServices.addPG_acceso = function (id,idAcceso, pg) {
  var currentUrl = window.location.hostname
  console.log(currentUrl)
  let formData = new FormData()
  formData.append('id', id)
  formData.append('idAcceso', idAcceso)
  formData.append('pg', pg)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    // url: '/updateRecepcion_Pg.php'
    url: '/SCA_Tuxpan/addAcceso_Pg.php'
  }
  if (currentUrl === url_local) {
    return bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
  } else {
    return bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
  }
}

autotanqueServices.updatePG_acceso = function (id, p1, p2, p3, p4, p5, p6, p7, p8, p9, p10, p11, p12, p13, p14, p15, p16, p17, p18, p19, p20, p21, p22, p23, emplazado, fechaEmplazado, observaciones, verif) {
  var currentUrl = window.location.hostname
  console.log(currentUrl)
  let formData = new FormData()
  formData.append('id', id)
  formData.append('p1', p1)
  formData.append('p2', p2)
  formData.append('p3', p3)
  formData.append('p4', p4)
  formData.append('p5', p5)
  formData.append('p6', p6)
  formData.append('p7', p7)
  formData.append('p8', p8)
  formData.append('p9', p9)
  formData.append('p10', p10)
  formData.append('p11', p11)
  formData.append('p12', p12)
  formData.append('p13', p13)
  formData.append('p14', p14)
  formData.append('p15', p15)
  formData.append('p16', p16)
  formData.append('p17', p17)
  formData.append('p18', p18)
  formData.append('p19', p19)
  formData.append('p20', p20)
  formData.append('p21', p21)
  formData.append('p22', p22)
  formData.append('p23', p23)
  formData.append('emp', emplazado)
  formData.append('fe', fechaEmplazado)
  formData.append('ob', observaciones)
  formData.append('ve', verif)
  
  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    // url: '/updateRecepcion_Pg.php'
    url: '/SCA_Tuxpan/updateAcceso_Pg.php'
  }
  if (currentUrl === url_local) {
    return bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
  } else {
    return bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
  }
}

autotanqueServices.salidaAutotanque = function (id, observaciones, emplazado, fechaEmplazado) {
  var currentUrl = window.location.hostname
  console.log(currentUrl)
  let formData = new FormData()
  formData.append('id', id)
  formData.append('observaciones', observaciones)
  formData.append('emplazado', emplazado)
  formData.append('fechaEmplazado', fechaEmplazado)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    // url: '/updateSalidaTanque.php'
    url: '/SCA_Tuxpan/updateSalidaTanque.php'
  }
  if (currentUrl === url_local) {
    return bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
  } else {
    return bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
  }

}

autotanqueServices.finishRecepcion = function (id, idDespacha, usuarioDespacha, fechaSalida) {
  var currentUrl = window.location.hostname
  console.log(currentUrl)
  let formData = new FormData()
  formData.append('id', id)
  formData.append('idDespacha', idDespacha)
  formData.append('usuarioDespacha', usuarioDespacha)
  formData.append('fechaSalida', fechaSalida)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    // url: '/finishRecepcion.php'
    url: '/SCA_Tuxpan/finishRecepcion.php'
  }
  if (currentUrl === url_local) {
    return bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
  } else {
    return bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })

  }

}

autotanqueServices.getIdEmbarque = function (idRecepcion, pg) {
  var currentUrl = window.location.hostname
  console.log(currentUrl)
  if (currentUrl === url_local) {
    return bdServices125.get(`/SCA_Tuxpan/data/getIdEmbarque_idRec.php?id=${idRecepcion}&pg=${pg}`)
      .then(res => res.data)
      .catch(e => console.log(e))
  } else {
    return bdServices.get(`/SCA_Tuxpan/data/getIdEmbarque_idRec.php?id=${idRecepcion}&pg=${pg}`)
      .then(res => res.data)
      .catch(e => console.log(e))
  }
}


autotanqueServices.updateEmbarque_salida = function (idEmbarque, fechaSalida) {
  var currentUrl = window.location.hostname
  console.log(currentUrl)
  let formData = new FormData()
  formData.append('embarque', idEmbarque)
  formData.append('fechaSalida', fechaSalida)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    // url: '/finishRecepcion.php'
    url: '/SCA_Tuxpan/updateIdEmbarque.php'
  }
  if (currentUrl === url_local) {
    return bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
  } else {
    return bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
  }

}

autotanqueServices.getPorteadores = function () {
  var currentUrl = window.location.hostname
  console.log(currentUrl)
  if (currentUrl === url_local) {
    return bdServices125.get('/SCA_Tuxpan/data/porteadores.php')
      .then(res => res.data)
      .catch(e => console.log(e))
  } else {
    return bdServices.get('/SCA_Tuxpan/data/porteadores.php')
      .then(res => res.data)
      .catch(e => console.log(e))
  }
  
}

autotanqueServices.getOperadores = function () {
  var currentUrl = window.location.hostname
  console.log(currentUrl)
  if (currentUrl === url_local) {
    return bdServices125.get('/SCA_Tuxpan/data/operadores.php')
      .then(res => res.data)
      .catch(e => console.log(e))
  } else {
    return bdServices.get('/SCA_Tuxpan/data/operadores.php')
      .then(res => res.data)
      .catch(e => console.log(e))
  }

}

autotanqueServices.deleteAcceso = function (claveTurno) {
  var currentUrl = window.location.hostname
  console.log(currentUrl)
  let formData = new FormData()
  formData.append('ct', claveTurno)
  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    // url: '/deleteRecepcion.php'
    url: '/SCA_Tuxpan/deleteAcceso.php'
  }

  if (currentUrl === url_local) {
    return bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
  } else {
    return bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
  }
}

autotanqueServices.deletePg_Puntos = function (idAcceso) {
  var currentUrl = window.location.hostname
  console.log(currentUrl)
  let formData = new FormData()
  formData.append('idA', idAcceso)
  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    // url: '/deletePgs_Recepcion.php'
    url: '/SCA_Tuxpan/deletePgs_Puntos.php'
  }
  if (currentUrl === url_local) {
    return bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
  } else {
    return bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
  }
}

autotanqueServices.deletePg_inRecepcion = function (idPg) {
  var currentUrl = window.location.hostname
  console.log(currentUrl)
  let formData = new FormData()
  formData.append('idPg', idPg)
  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    // url: '/deletePgs_Recepcion.php'
    url: '/SCA_Tuxpan/deletePg_inRecepcion.php'
  }
  if (currentUrl === url_local) {
    return bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
  } else {
    return bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
  }
}

autotanqueServices.addPG_Emplazamiento = function (id, fechaReg, pg, observaciones, instante, estado, idVerificacion, idEmplaza) {
  var currentUrl = window.location.hostname
  console.log(currentUrl)
  let formData = new FormData()
  formData.append('id', id)
  formData.append('fechaReg', fechaReg)
  formData.append('pg', pg)
  formData.append('observaciones', observaciones)
  formData.append('instante', instante)
  formData.append('estado', estado)
  formData.append('idVerificacion', idVerificacion)
  formData.append('idEmplaza', idEmplaza)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    // url: '/addEmplazamiento.php'
    url: '/SCA_Tuxpan/addEmplazamiento.php'
  }
  if (currentUrl === url_local) {
    return bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
  } else {
    return bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
  }
}

autotanqueServices.checkPg = function (idPG) {
  var currentUrl = window.location.hostname
  console.log(currentUrl)
  console.log(idPG)
  if (currentUrl === url_local) {
    return bdServices125.get(`/SCA_Tuxpan/data/autotanqueCheck.php?idPg=${idPG}`)
      .then(res => res.data)
      .catch(e => console.log(e))
  } else {
    return bdServices.get(`/SCA_Tuxpan/data/autotanqueCheck.php?idPg=${idPG}`)
      .then(res => res.data)
      .catch(e => console.log(e))
  }
  
}


autotanqueServices.enviarFirmaPuntos = function (id, firma, nombreFile) {
  var currentUrl = window.location.hostname
  console.log(currentUrl)
  let formData = new FormData()
  formData.append('id', id)
  formData.append('firma', firma)
  formData.append('nombreFile', nombreFile)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    // url: '/addEmplazamiento.php'
    url: '/SCA_Tuxpan/addFirmaPuntos.php'
  }
  if (currentUrl === url_local) {
    return bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
  } else {
    return bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
  }
}

autotanqueServices.guadarOperador = function (id, nombre) {
  var currentUrl = window.location.hostname
  console.log(currentUrl)
  let formData = new FormData()
  formData.append('idO', id)
  formData.append('nombreO', nombre)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    // url: '/addEmplazamiento.php'
    url: '/SCA_Tuxpan/addOperador.php'
  }
  if (currentUrl === url_local) {
    return bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
  } else {
    return bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
  }
}

autotanqueServices.getIdTanque = function () {
  var currentUrl = window.location.hostname
  console.log(currentUrl)
  if (currentUrl === url_local) {
    return bdServices125.get(`/SCA_Tuxpan/data/getIdTanque.php`)
      .then(res => res.data)
      .catch(e => console.log(e))
  } else {
    return bdServices.get(`/SCA_Tuxpan/data/getIdTanque.php`)
      .then(res => res.data)
      .catch(e => console.log(e))
  }
  
}


autotanqueServices.guardarTanque = function (id, pg, comercializadora, porteador, grupo, capacidad, placa, fechaMod, idCRE) {
  var currentUrl = window.location.hostname
  console.log(currentUrl)
  let formData = new FormData()
  formData.append('id', id)
  formData.append('nombre', pg)
  formData.append('grupo', grupo)
  formData.append('comer', comercializadora)
  formData.append('porteador', porteador)
  formData.append('capacidad', capacidad)
  formData.append('placa', placa)
  formData.append('fecha', fechaMod)
  formData.append('idCRE', idCRE)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    // url: '/addEmplazamiento.php'
    url: '/SCA_Tuxpan/addAutotanque.php'
  }
  if (currentUrl === url_local) {
    return bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
  } else {
    return bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
  }
}

autotanqueServices.actualizarTanque = function (id, comercializadora, porteador, grupo, capacidad, placa, idCRE) {
  var currentUrl = window.location.hostname
  console.log(currentUrl)
  let formData = new FormData()
  formData.append('id', id)
  formData.append('grupo', grupo)
  formData.append('comer', comercializadora)
  formData.append('porteador', porteador)
  formData.append('capacidad', capacidad)
  formData.append('placa', placa)
  formData.append('idCRE', idCRE)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    // url: '/addEmplazamiento.php'
    url: '/SCA_Tuxpan/updateAutotanque.php'
  }
  if (currentUrl === url_local) {
    return bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
  } else {
    return bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
  }
}

autotanqueServices.actualizarOperador = function (id, telefono, identificacion, file ) {
  var currentUrl = window.location.hostname
  console.log(currentUrl)
  let formData = new FormData()
  formData.append('id', id)
  formData.append('te', telefono)
  formData.append('iden', identificacion)
  formData.append('file', file)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    // url: '/addEmplazamiento.php'
    url: '/SCA_Tuxpan/updateOperador.php'
  }
  if (currentUrl === url_local) {
    return bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
  } else {
    return bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
  }
}

autotanqueServices.getAutos_claveTurno = function (claveTurno) {
  var currentUrl = window.location.hostname
  console.log(currentUrl)
  if (currentUrl === url_local) {
    return bdServices125.get(`/SCA_Tuxpan/data/getAccesos_CT.php?ct=${claveTurno}`)
      .then(res => res.data)
      .catch(e => console.log(e))
  } else {
    return bdServices.get(`/SCA_Tuxpan/data/getAccesos_CT.php?ct=${claveTurno}`)
      .then(res => res.data)
      .catch(e => console.log(e))
  }
  
}

autotanqueServices.updateAcceso_Inicio = function (id, pg, claveTurno, idOperador, nombreOpeador, telefonoOperador, fotoOperador, subgrupo) {
  var currentUrl = window.location.hostname
  console.log(currentUrl)
  let formData = new FormData()
  formData.append('id', id)
  formData.append('pg', pg)
  formData.append('claveTurno', claveTurno)
  formData.append('idOperador', idOperador)
  formData.append('nombreOpeador', nombreOpeador)
  formData.append('telefonoOperador', telefonoOperador)
  formData.append('fotoOperador', fotoOperador)
  formData.append('subgrupo', subgrupo)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    // url: '/addEmplazamiento.php'
    url: '/SCA_Tuxpan/updateAcceso_Inicio.php'
  }
  if (currentUrl === url_local) {
    return bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
  } else {
    return bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
  }

}

autotanqueServices.updatePuntosPG_Inicio = function (idAcceso, pg) {
  var currentUrl = window.location.hostname
  console.log(currentUrl)
  let formData = new FormData()
  formData.append('idAcceso', idAcceso)
  formData.append('pg', pg)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    // url: '/addEmplazamiento.php'
    url: '/SCA_Tuxpan/updatePuntosPG_Inicio.php'
  }
  if (currentUrl === url_local) {
    return bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
  } else {
    return bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
  }

}

autotanqueServices.deleteAcceso_Id = function (idAcceso) {
  var currentUrl = window.location.hostname
  console.log(currentUrl)
  let formData = new FormData()
  formData.append('id', idAcceso)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    // url: '/addEmplazamiento.php'
    url: '/SCA_Tuxpan/deleteAcceso_id.php'
  }
  if (currentUrl === url_local) {
    return bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
  } else {
    return bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
  }

}

autotanqueServices.firmarPuntos = function (id, firma, nombreFile) {
  var currentUrl = window.location.hostname
  console.log(currentUrl)
  let formData = new FormData()
  formData.append('id', id)
  formData.append('firma', firma)
  formData.append('nombreFile', nombreFile)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'multipart/form-data' },
    data: formData,
    url: '/SCA_Tuxpan/addFirmaPuntos.php'
  }

  if (currentUrl === url_local) {
    return bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
  } else {
    return bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
  }
}

export default autotanqueServices



// WEBPACK FOOTER //
// ./src/services/autotanque.js